module.exports = __webpack_public_path__ + "static/media/cd_mp3_player.48d5a4c2.svg";